import { TranslationObject } from '../../i18n/translation';

const namespace = 'icons';
const translations: TranslationObject = {
  alert: {
    id: `${namespace}.alert`,
    nb: 'Merk',
    en: 'Alert',
  },
  info: {
    id: `${namespace}.info`,
    nb: 'Info',
    en: 'Info',
  },
  open: {
    id: `${namespace}.open`,
    nb: 'Åpne',
    en: 'Open',
  },
  close: {
    id: `${namespace}.close`,
    nb: 'Lukk',
    en: 'Close',
  },
  upload: {
    id: `${namespace}.upload`,
    nb: 'Last opp',
    en: 'upload',
  },
  endnode: {
    id: `${namespace}.endnode`,
    nb: 'Endenode',
    en: 'Endnode',
  },
  dashboard: {
    id: `${namespace}.dashboard`,
    nb: 'Dashbord',
    en: 'Dashboard',
  },
  dateRange: {
    id: `${namespace}.dateRange`,
    nb: 'kalender',
    en: 'calendar',
  },
  settings: {
    id: `${namespace}.settings`,
    nb: 'Innstillinger',
    en: 'Settings',
  },
  accountBalance: {
    id: `${namespace}.accountBalance`,
    nb: 'mininstitusjon',
    en: 'myinstitution',
  },
  exitToAppRounded: {
    id: `${namespace}.exitToAppRounded`,
    nb: 'loggut',
    en: 'logout',
  },
  addCircleRounded: {
    id: `${namespace}.addCircleRounded`,
    nb: 'leggtil',
    en: 'add',
  },
  edit: {
    id: `${namespace}.edit`,
    nb: 'rediger',
    en: 'edit',
  },
  delete: {
    id: `${namespace}.delete`,
    nb: 'slett',
    en: 'delete',
  },
  arrowDropDown: {
    id: `${namespace}.arrowDropDown`,
    nb: 'dropdown',
    en: 'dropdown',
  },
  checkCircle: {
    id: `${namespace}.checkCircle`,
    nb: 'hake',
    en: 'checkmark',
  },
  checkCircleOutline: {
    id: `${namespace}.checkCircleOutline`,
    nb: 'hake',
    en: 'checkmark',
  },
  radioButtonUnchecked: {
    id: `${namespace}.radioButtonUnchecked`,
    nb: 'radioknapp',
    en: 'radiobutton',
  },
  help: {
    id: `${namespace}.help`,
    nb: 'hjelp',
    en: 'help',
  },
  search: {
    id: `${namespace}.search`,
    nb: 'Søk',
    en: 'Search',
  },
  clear: {
    id: `${namespace}.clear`,
    nb: 'Tøm',
    en: 'Clear',
  },
  checkBox: {
    id: `${namespace}.checkBox`,
    nb: 'Fjern markering',
    en: 'Uncheck',
  },
  checkBoxOutline: {
    id: `${namespace}.checkBoxOutline`,
    nb: 'Huk av',
    en: 'Check',
  },
  indeterminateCheckBox: {
    id: `${namespace}.indeterminateCheckBox`,
    nb: 'Ubestemt',
    en: 'Indeterminate',
  },
  check: {
    id: `${namespace}.check`,
    nb: 'Hake',
    en: 'Check',
  },
  group: {
    id: `${namespace}.group`,
    nb: 'Gruppe',
    en: 'Group',
  },
  fileUpload: {
    id: `${namespace}.fileUpload`,
    nb: 'Last opp fil',
    en: 'Upload file',
  },
  fileUploaded: {
    id: `${namespace}.fileUploaded`,
    nb: 'Fil er lastet opp',
    en: 'File is uploaded',
  },
  pdfFile: {
    id: `${namespace}.pdfFile`,
    nb: 'PDF-fil',
    en: 'PDF file',
  },
  locationOn: {
    id: `${namespace}.locationOn`,
    nb: 'Stedsinformasjon',
    en: 'Place information',
  },
  move: {
    id: `${namespace}.move`,
    nb: 'Flytt',
    en: 'Move',
  },
  warning: {
    id: `${namespace}.warning`,
    nb: 'Advarsel',
    en: 'Warning',
  },
  openInNew: {
    id: `${namespace}.openInNew`,
    nb: 'Åpne i ny fane',
    en: 'Open in new tab',
  },
  evaluation: {
    id: `${namespace}.evaluation`,
    nb: 'Vurdering',
    en: 'Assesment',
  },
};

export default translations;
